export default __webpack_public_path__ + "static/media/Rosneft.2bf6b42e.svg";